import React, { useEffect, useState } from 'react';
import { Popover, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MaterialTypography from '../../../../../../components/MaterialTypography';
import MaterialButton from '../../../../../../components/MaterialButton';
import { useLocation, useNavigate } from 'react-router-dom';
import BASEURL from '../../../../../../pages/Utils/Baseurl';
import request from 'graphql-request';
import { useAuth } from '../../../../../../context/AuthContext/AuthContextProvider';

const NotificationBar = ({ anchorEl, onClose, open,length,setLength }) => {

    const { currentUser } = useAuth();
    const params = useLocation();
    const id = params.search.slice(1);
    const decodedId = atob(currentUser?.id);
    const userId = decodedId.split(":")[1];
    const navigate = useNavigate();  
    const [notifications, setNotifications] = useState([]);
    useEffect(() => {
        if ( userId) {
        fetchNotifications();
        }
    }, [ userId]);

    const fetchNotifications = async () => {
    const query = `
      query AllNotifications($userId: Int!, $isRead: Boolean!) {
        allNotifications(userId: $userId, isRead: $isRead) {
          success
          message
          data {
            id
            message
            isRead
            task{
              title
            }
            notificationType
            createdAt
          }
        }
      }
    `;

    const variables = {
      userId: userId,
      // userId: "3",
      isRead: false,
    };

    try {
      const response = await request(BASEURL, query, variables);
      const data = response?.allNotifications?.data || [];
      setNotifications(data);
      setLength(data.length);            
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
    };


  const handleNavigate = () => {
    onClose();
    navigate("/notification");
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      overflowY= "auto"
      overflowX= "hidden"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          width: 320,
          p: 2,
          borderRadius: 2,
          bgcolor: '#fff',
          boxShadow: 4,
        }
      }}
    >
      <Box position="relative">
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <MaterialTypography 
          fontWeight="regular">
            NOTIFICATIONS ({notifications.length})
          </MaterialTypography>
        </Box>

        {notifications.map((item) => (
          <Box key={item.id} 
          onClick={() =>
            navigate(`/notification/view-notification?${notifications[0].id}`)
          }
          sx={{ p: 1, borderRadius: 2, backgroundColor: '#f0e7f7', mb: 1,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#e0d2ec'
            }
           }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <MaterialTypography fontWeight="bold" variant="body2">
              {item.notificationType}
            </MaterialTypography>
            <MaterialTypography variant="caption" sx={{ fontSize: '0.7rem' }}>
              {item.createdAt.slice(0,10)}
            </MaterialTypography>
          </Box>
          <MaterialTypography variant="body2">
            {(item.task?.title).length > 25 ? item.task?.title.slice(0, 25) + "..." : item.task?.title}
          </MaterialTypography>
        </Box>
        
        ))}

        <Box mt={1} textAlign="center">
          <MaterialButton
            size="small"
            variant="contained"
            color="primary"
            onClick={handleNavigate}
          >
            VIEW ALL
          </MaterialButton>
        </Box>
      </Box>
    </Popover>
  );
};

export default NotificationBar;
